import type { FC } from 'react';

export const NotificationBadge: FC<{ count: number }> = ({ count }) => {
	return (
		<div className="absolute -right-2 -top-2 flex size-5 items-center justify-center rounded-full bg-[var(--skin-text)] text-xs font-bold text-[var(--skin-bg)]">
			{count}
		</div>
	);
};
